import { Being } from "./Being";
import { Beast } from "./Beast";
import { Direction, landThresholds as thresholds, AI } from "./constants";

export class Surroundings {
    public altitude: number;
    public sightLines: Map<Direction, (number | null)[]>;
    public nearbyBeings: Being[];
    // Per-direction change in distance-to-nearest-edge for the first step.
    // +1 = moves one cell deeper inland, 0 = parallel to edge, -1 = toward edge.
    public edgeDelta: Map<Direction, number>;
    // Being's current grid distance to the nearest map edge.
    public edgeDist: number;
    /** Beasts within detection range of this entity. Empty in Level 1. */
    public nearbyBeasts: Beast[];

    constructor(
        altitude: number,
        sightLines: Map<Direction, (number | null)[]>,
        nearbyBeings: Being[],
        edgeDelta: Map<Direction, number>,
        edgeDist: number,
        nearbyBeasts: Beast[] = []
    ) {
        this.altitude = altitude;
        this.sightLines = sightLines;
        this.nearbyBeings = nearbyBeings;
        this.edgeDelta = edgeDelta;
        this.edgeDist = edgeDist;
        this.nearbyBeasts = nearbyBeasts;
    }

    /**
     * The amount of food available at this altitude per tick.
     * Returns 0 underwater or above the mountain threshold.
     * Low land gives a healthy surplus; highland exactly breaks even with base decay.
     */
    public get availableFood(): number {
        if (this.altitude < thresholds.sea) return 0;
        if (this.altitude < thresholds.highland) return AI.FOOD_LOW_LAND;
        if (this.altitude < thresholds.mountain) return AI.FOOD_HIGHLAND;
        return 0;
    }

    public get isInDanger(): boolean {
        return this.altitude < thresholds.sea || this.altitude > thresholds.mountain;
    }
}
